import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserCog } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/util";
import { Section } from "@/components/common";

export default function StaffActivity() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/audit/staff-activity").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;
  return (
    <Section title="نشاط موظفي الإدارة" action={<Link to="/admin/audit?role=staff" data-testid="staff-activity-all" className="text-blue-700 font-bold">السجل الكامل</Link>}>
      <div data-testid="staff-activity">
        {d.today.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-3">
            {d.today.map((p) => (
              <Link key={p.user_id} to={`/admin/audit?user_id=${p.user_id}`} data-testid={`staff-today-${p.user_id}`} className="bg-blue-50 text-brand rounded-full px-3 py-1 text-sm font-bold">
                {p.name}: {p.count} إجراء اليوم</Link>
            ))}
          </div>
        )}
        {d.recent.length === 0 ? <p className="text-slate-500 text-sm py-4 flex items-center gap-2"><UserCog className="w-4 h-4" />لا يوجد نشاط للموظفين بعد</p> : (
          <div className="divide-y">
            {d.recent.map((a) => (
              <div key={a.id} data-testid={`staff-action-${a.id}`} className="py-2 text-sm flex justify-between gap-3">
                <span><b>{a.user_name}</b> — {a.action}</span>
                <span className="text-slate-500 whitespace-nowrap">{fmtDateTime(a.at)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </Section>
  );
}
